import yup from '../../../config/yup';

export const updateFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Statement ID',
    },
    '@data-type': {
      type: 'string',
      title: 'Data Type',
      default: 'dataframe',
    },
    '@ref-connector': {
      type: 'string',
      title: 'Reference Connector',
    },
    '@ref-connector-id': {
      type: 'string',
      title: 'Reference Connector ID',
    },
    '@ref-dataframe-id': {
      type: 'string',
      title: 'Reference DataFrame ID',
    },
    '@ref-dataframe-name': {
      type: 'string',
      title: 'Reference DataFrame Name',
    },
    action: {
      type: 'string',
      title: 'Action',
      default: 'update',
    },
    'data-frame': {
      type: 'string',
      title: 'Data Frame',
    },
    query: {
      type: 'string',
      title: 'Query',
    },
  },
  required: [
    '@id',
    '@data-type',
    '@ref-connector',
    '@ref-connector-id',
    '@ref-dataframe-id',
    '@ref-dataframe-name',
    'action',
    'data-frame',
    'query',
  ],
};

export const updateFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated after saving',
  },
  '@data-type': {
    'ui:readonly': true,
  },
  action: {
    'ui:readonly': true,
  },
  query: {
    'ui:widget': 'textarea',
    'ui:rows': 10,
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
  '@ref-connector-id': {
    'ui:readonly': true,
  },
  '@ref-connector': {
    'ui:readonly': true,
  },
  '@ref-dataframe-id': {
    'ui:readonly': true,
  },
  '@ref-dataframe-name': {
    'ui:readonly': true,
  },
};

export const updateValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('dataframe'),
  type: yup.string().default('update'),
  action: yup.string().default('update').required('Action is required'),
  'data-frame': yup.string().required('Data Frame is required'),
  query: yup.string().required('Query is required'),
});
